var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container has-text-centered"},[_c('small',{staticClass:"has-text-ddlight"},[_vm._v(_vm._s(_vm.currentYear)+" © FoxSolution | All Rights Reserved. ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }